import { SET_ADDCOMMENT } from '../actions';

const commentadd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDCOMMENT:
      return [...action.value];  
    default: return state;
  }
}

export default commentadd;
